
export const PENDING_COMPANY_CONTEXT_KEY = 'pendingCompanyContext';

export interface PendingCompanyContext {
  companyId: number;
  productContextId?: number;
}

export function storePendingCompanyContext(value: PendingCompanyContext): void {
  sessionStorage.setItem(PENDING_COMPANY_CONTEXT_KEY, JSON.stringify(value));
}

export function consumePendingCompanyContext(): PendingCompanyContext | null {
  const raw = sessionStorage.getItem(PENDING_COMPANY_CONTEXT_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(PENDING_COMPANY_CONTEXT_KEY);
  try {
    return JSON.parse(raw) as PendingCompanyContext;
  } catch {
    return null;
  }
}

